import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext.js';

/**
 * Admin-only routes (staff/user management — the Team screen).
 *
 * Manager is near-Admin everywhere else, but staff management stays ADMIN-only
 * even for Manager (staff-RBAC, 2026-08-10). The survey editor moved to
 * RequireManager, which also admits Manager. Sits inside RequireAuth, so `user`
 * is already resolved — a non-admin who types the URL goes to the dashboard
 * rather than an error. The backend enforces the same rule; this only keeps
 * the UI honest.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (user !== null && user.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
